import type {Code} from 'services/codelists/types';

export const getCodeLabel = (option: Code, showCode?: boolean) =>
  showCode ? `${option.code}: ${option.value}` : option.value;
